import React, {useState} from "react"
import {useDispatch} from "react-redux";
import {Card, CardBody, Col, Input, InputGroup, Row} from "reactstrap"
import {getAllLogisticProducts, searchProductForWarehouse} from "../../store/products/actions";
// import {getProductCategories, searchProductCategories} from "../../../store/Category/actions";


const FilterComponent = props => {
    const dispatch = useDispatch()
    const [searchTerm, setSearchTerm] = useState('');

    const handleChange = (event) => {
        setSearchTerm(event.target.value)

        let vl = event.target.value
        if (vl.length >= 3) {
            const filters = {
                search: vl,
            };
            const queryParams = new URLSearchParams(filters).toString();

            let item = {
                id :vl
            }
            dispatch(searchProductForWarehouse(item))
        } else {
            const filters = {
                skip: props.skip.toString(),
                limit: props.limit.toString(),
                country: props.country,
                status: 'waiting',
                creater: 'admin',
                branch:'all',
            };

            const queryParams = new URLSearchParams(filters).toString();
            dispatch(getAllLogisticProducts(queryParams))
        }
    };

    const clearSearch = () =>{
        setSearchTerm('')
        const filters = {
            skip: props.skip.toString(),
            limit: props.limit.toString(),
            country: props.country,
            status: 'waiting',
            creater: 'admin',
            branch:'all',
        };

        const queryParams = new URLSearchParams(filters).toString();
        dispatch(getAllLogisticProducts(queryParams))
    }



    return (
        <React.Fragment>
            <Col xl={12}>
                <Card>
                    <CardBody>
                        <Row>
                            <Col md={3}>
                                <InputGroup>
                                    <div className="input-group-text"> <i className="uil uil-search search-icon"></i></div>
                                    <Input
                                        type="text"
                                        className="form-control bg-light border-light rounded"
                                        placeholder="Search..."
                                        value={searchTerm}
                                        onChange={handleChange}
                                    />
                                    {searchTerm.length > 0 && (
                                        <span className="input-group-text cursor-pointer" >
                                                <i className="uil uil-times-circle clear-icon" onClick={clearSearch}></i>
                                            </span>
                                    )}
                                </InputGroup>
                            </Col>
                            <Col md={8} className="mt-1">
                                {/*    <div className="hstack gap-3 ">
                                            <div className="bg-light border">First item</div>
                                            <div className="vr"></div>
                                            <div className="bg-light border">First item</div>
                                            <div className="vr"></div>
                                        </div>*/}
                            </Col>
                        </Row>

                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>

    )
}

export default FilterComponent
